import { inject, Pipe, PipeTransform } from '@angular/core';
import { AutoActivationMode } from '@common/models/users/auto-activation-mode.model';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';

@Pipe({
  name: 'autoActivationMode',
  pure: true
})
export class AutoActivationModePipe implements PipeTransform {
  private readonly i18nPipe = inject(I18NextPipe);

  private readonly moduleUsers = I18_NAMESPACE_APPS_UI.users;

  transform(mode: AutoActivationMode): string {
    switch (mode) {
      case AutoActivationMode.AllUsers:
        return this.i18nPipe.transform(this.moduleUsers + ':grid.allUsers', { format: 'capitalize' });
      case AutoActivationMode.NewUsers:
        return this.i18nPipe.transform(this.moduleUsers + ':grid.newCreated', { format: 'capitalize' });
      case AutoActivationMode.Disabled:
        return this.i18nPipe.transform(this.moduleUsers + ':grid.disabled', { format: 'capitalize' });
      default:
        return '';
    }
  }
}
